export enum OrganizationMessage {
  ORGANIZATION_CREATE_SUCCESSFUL = 'Organization created successfully.',
  ORGANIZATION_UPDATE_SUCCESSFUL = 'Organization updated successfully.',
  ORGANIZATION_DELETE_SUCCESSFUL = 'Organization deleted successfully.',
  LOGGED_IN_AS_ORGANIZATION = 'Successfully switched organization.'
}
